import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Link from '../Link';
import history from '../../core/history';
import { photosShow } from '../../helpers/photosShow';
import { logouploadDir } from '../../config';
import s from './Logo.css';

const Logo = (props) => {
    const { siteName, logoImage, link = '/', className, showMenu = false, homePageLogo, layoutType, } = props;
    const location = history?.location?.pathname || null;
    const [isClient, setClient] = useState(false);
    let path = photosShow(logouploadDir);
    useEffect(() => {
        setClient(true);
    });

    const renderImage = (logo) => {
        return <img src={path + logo} className={cx(!showMenu ? 'displayBlock' : 'displayNone')} alt="logo" />
    };

    const renderSiteName = (colorClass = s.logoColor) => {
        return <span className={cx(colorClass)}>{siteName}</span>
    };

    return (
        isClient ? <Link to={link} className={className}>
            {homePageLogo && location === '/' && !logoImage && layoutType != 2 && renderImage(homePageLogo)}
            {homePageLogo && location === '/' && !logoImage && showMenu && renderSiteName()}
            {homePageLogo && location === '/' && logoImage && layoutType != 2 && renderImage(homePageLogo)}
            {homePageLogo && location === '/' && logoImage && layoutType == 2 && renderImage(logoImage)}
            {homePageLogo && location == '/' && showMenu && logoImage && renderImage(logoImage)}
            {!homePageLogo && location === '/' && logoImage && renderImage(logoImage)}
            {!homePageLogo && !logoImage && siteName && location && location !== '/' && renderSiteName()}
            {!homePageLogo && !logoImage && siteName && location && location === '/' && <span className={cx(!showMenu ? s.whiteColor : s.logoColor)}>{siteName}</span>}
            {logoImage && location && location !== '/' && renderImage(logoImage)}
            {!logoImage && homePageLogo && location && location !== '/' && siteName && renderSiteName()}
            {!logoImage && !homePageLogo && location && location !== '/' && siteName && !layoutType == 2 && renderSiteName()}
        </Link> : <></>
    );
};

Logo.propTypes = {
    siteName: PropTypes.string.isRequired,
    logoImage: PropTypes.string,
    link: PropTypes.string,
    className: PropTypes.string,
    showMenu: PropTypes.bool,
    homePageLogo: PropTypes.string,
    layoutType: PropTypes.number,
};

const mapState = (state) => ({
    siteName: state?.siteSettings?.data?.siteName,
    logoImage: state?.siteSettings?.data?.Logo,
    homePageLogo: state?.siteSettings?.data?.homePageLogo,
    showMenu: state?.toggle?.showMenu,
    layoutType: state?.siteSettings?.data?.homePageType,
});

export default withStyles(s)(connect(mapState)(Logo));